import { chartColors } from '@scality/core-ui/dist/style/theme';
import { useMemo } from 'react';

export const useSeriesColor = (labelCollection: { label: string }[]) => {
  return useMemo(() => {
    const colors = Object.values(chartColors);
    return labelCollection.reduce<Record<string, string>>((acc, item, index) => {
      acc[item.label] = colors[index % colors.length];
      return acc;
    }, {});
  }, [labelCollection]);
};
